import { AppButton } from 'components/form';
import { Input } from '@trackman/web-shared-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type TextFieldsFilterProps = {
  filter: { inputs: any[]; type: string };
  onApply: (value?: any) => void;
};

export const TextFieldsFilter = ({ filter, onApply }: TextFieldsFilterProps) => {
  const [values, setValues] = useState<Record<string, string>>({});
  const { t } = useTranslation();

  return (
    <div className='data-table-filter-content gap-10px'>
      {filter?.inputs?.map((single, i) => {
        return (
          <Input
            key={i}
            label={single?.label || ''}
            defaultValue={values?.[i] || ''}
            autoFocus={single?.autoFocus || false}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const newValues = { ...(values || {}) };
              newValues[single.id] = e.currentTarget.value;
              setValues(newValues);
            }}
            onKeyDown={(e) => e.key === 'Enter' && onApply(values)}
          />
        );
      })}

      <AppButton
        data-test='ApplyTextFieldFilterSubmit'
        type='button'
        className='apply-button '
        variant='primary'
        onClick={() => onApply(values)}
      >
        {t('apply')}
      </AppButton>
    </div>
  );
};

export default TextFieldsFilter;
